import client from './client';

export interface RecruitmentLog {
  id?: string;
  log_type?: string;
  candidate_id?: number;
  candidate_name?: string;
  candidate_number?: string;
  operator: string;
  event: string;
  stage?: string;
  result?: string;
  comments?: string;
  operation_time: string;
}

export interface GetLogsParams {
  page?: number;
  page_size?: number;
  /** 关键词：候选人姓名 / 候选人序号 / 操作人 */
  keyword?: string;
  stage?: string;
  start_date?: string;
  end_date?: string;
  candidate_id?: number;
}

export interface GetLogsResponse {
  logs: RecruitmentLog[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

// 获取招聘日志列表（服务端分页 + 服务端筛选）
export const getRecruitmentLogs = async (params: GetLogsParams): Promise<GetLogsResponse> => {
  const response = await client.get('/recruitment-log/list', { params });
  return response.data;
};
